/* eslint-disable unicorn/no-null */
import { ReactNode } from 'react';

import { Spinner } from '../spinner/spinner';
import { Tree } from '../tree/tree';
import { TreeProps } from '../tree/tree.types';

export interface TreeComboBoxContentsProps extends TreeProps {
  displayDropdown: boolean;
  isLoading?: boolean;
  /** Ref to the bottom of the dropdown. Useful for infinite scroll */
  bottomRef?: (node?: Element | null | undefined) => void;
  bottomContent?: ReactNode;
}

export const TreeComboBoxContents = (props: TreeComboBoxContentsProps) => {
  const { displayDropdown, isLoading = false, bottomRef, bottomContent, ...rest } = props;

  if (isLoading) {
    return (
      <div className="popover-spinner-wrapper">
        <Spinner />
      </div>
    );
  }
  if (!displayDropdown) return null;

  return (
    <div role="menu" className="popover-menu">
      <div className="popover-menu-content p-4">
        <Tree {...rest} />
        <div ref={bottomRef} />
      </div>
      {bottomContent && <div className="popover-menu-bottom-content">{bottomContent}</div>}
    </div>
  );
};

export default TreeComboBoxContents;
